import script from "./OrderLst.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderLst.vue?vue&type=script&setup=true&lang=js"

import "./OrderLst.vue?vue&type=style&index=0&id=5ae3bace&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae3bace"]])

export default __exports__